// extracted by mini-css-extract-plugin
export default {"coverCont":"PageCover-module__coverCont--GUaEi","pageCover":"PageCover-module__pageCover--qub+Z"};